import { z } from 'zod';
import { emailSchema, personNameSchema, uuidSchema } from './common.js';
import { permissionSchema } from './permissions.js';
export const createUserSchema = z.object({
    lastName: personNameSchema,
    firstName: personNameSchema,
    email: emailSchema,
    roleId: uuidSchema,
});
export const updateUserSchema = z.object({
    lastName: personNameSchema.optional(),
    firstName: personNameSchema.optional(),
    roleId: uuidSchema.optional(),
});
export const createRoleSchema = z.object({
    code: z
        .string()
        .trim()
        .min(2, 'Код не короче двух символов')
        .max(40)
        .regex(/^[a-z][a-z0-9_]*$/, 'Латиница в нижнем регистре, цифры и подчёркивание'),
    name: z.string().trim().min(1, 'Укажите название').max(80),
    description: z.string().trim().max(300).optional(),
    department: z.string().trim().max(80).optional(),
    permissions: z.array(permissionSchema).default([]),
});
export const updateRoleSchema = z.object({
    name: z.string().trim().min(1).max(80).optional(),
    description: z.string().trim().max(300).nullable().optional(),
    department: z.string().trim().max(80).nullable().optional(),
    permissions: z.array(permissionSchema).optional(),
});
export const upsertBlockSchema = z.object({
    title: z.string().trim().min(1, 'Укажите название').max(200),
    body: z.string().trim().max(20_000).default(''),
    videoUrl: z.string().trim().url('Проверьте ссылку на видео').nullable().optional(),
    kind: z.enum(['regular', 'final']).default('regular'),
    isPublished: z.boolean().default(true),
});
export const reorderBlocksSchema = z.object({
    order: z.array(uuidSchema).min(1),
});
export const upsertQuestionSchema = z.object({
    text: z.string().trim().min(1, 'Сформулируйте вопрос').max(500),
    feedbackCorrect: z.string().trim().min(1, 'Текст для верного ответа').max(500),
    feedbackWrong: z.string().trim().min(1, 'Текст для неверного ответа').max(500),
    options: z
        .array(z.object({
        text: z.string().trim().min(1, 'Заполните вариант').max(300),
        isCorrect: z.boolean().default(false),
    }))
        .min(2, 'Нужно хотя бы два варианта')
        .max(8)
        // Ровно один верный: иначе непонятно, что подсвечивать зелёным
        // и как считать результат.
        .refine((options) => options.filter((o) => o.isCorrect).length === 1, {
        message: 'Отметьте ровно один верный вариант',
    }),
});
export const updateSettingsSchema = z.object({
    values: z.record(z.string(), z.unknown()),
});
export const markBlockSchema = z.object({
    completed: z.boolean(),
});
//# sourceMappingURL=admin.js.map